<template>
  <div>
    <template v-if="determinesModuleInspection(modules) && tag === 'li'  && type === 'api'">
      <router-link
        :to="{ name: determineModule(modules, defaultRoute) }"
        custom v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li class="nav-item" :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
          <template v-if="icon">
            <icon :name="icon"></icon>
          </template>
          <template v-if="text">
            <a :active="isActive" :href="href" @click="navigate" @keypress.enter="navigate" role="link" class="nav-link" :class="{'active': isActive}">{{ text }}</a>
          </template>
        </li>
      </router-link>
    </template>
    <template v-else-if="determinesModuleInspection(modules) && tag === 'li'  && type === 'web'">
      <li class="nav-item">
        <a
          :href="determineModule(modules, defaultRoute)"
          class="nav-link"
        >
          {{ text }}
        </a>
      </li>
    </template>
    <template v-else-if="determinesModuleInspection(modules) && tag === 'a' && type === 'api'">
      <router-link
        :to="{ name: determineModule(modules, defaultRoute) }"
        custom v-slot="{ href, navigate, isActive }"
      >
        <a :active="isActive" :href="href" @click="navigate" @keypress.enter="navigate" role="link" class="nav-link" :class="[{'active': isActive}, additionalClasses]">
          <template v-if="icon">
            <icon :name="icon"></icon>
          </template>
          <template v-if="text">
            {{ text }}
          </template>
        </a>
      </router-link>
    </template>
  </div>
</template>
<script>
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'v-weirdo-router-link',
  props: {
    tag: {
      type: String,
      default: () => {
        return 'li'
      },
    },
    type: {
      type: String,
      default: () => {
        return 'api'
      },
    },
    icon: {
      type: String,
      default: null,
    },
    modules: {
      type: Array,
      default: () => {
        return []
      },
    },
    defaultRoute: {
      type: String,
      default: () => {
        return '#'
      },
    },
    text: {
      type: String,
      default: null,
    },
    additionalClasses: {
      type: String,
      default: null,
    },
  },
}
</script>
<style scoped>
.nav-tabs .nav-link.active {
  background-color: #D0D3D4;
  border-left-color: #979A9A;
  border-right-color: #979A9A;
}
</style>
